import { fillArray } from 'lib/array/arrayUtils'
import uuidV4 from 'lib/string/uuidV4Utils'
import { getVariantSellerId } from 'lib/merchandise/getVariantSeller'

interface GenerateMerchandiseCartItemOptions {
  shippingId?: string
}

export function generateMerchandiseCartItem(
  offer: App.MerchandiseOffer,
  variant: App.MerchandiseOfferVariant,
  options: GenerateMerchandiseCartItemOptions = {},
): App.Checkout.MerchandiseItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: 'merchandise',
    advertId: offer.id,
    variantId: variant.id,
    sellerId: getVariantSellerId(offer, variant),
    shippingId: options.shippingId,
    shippingProfileId: variant.shippingProfileId,
  }
}

export function generateMerchandiseShippingCartItem(variantId: string, shippingProfileId?: string): App.Checkout.MerchandiseShippingItem {
  return {
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    itemType: 'merchandise-shipping',
    shippingId: uuidV4(),
    variantId,
    shippingProfileId,
  }
}

interface GenerateMerchandiseCartItemsOptions {
  quantity?: number
}

export function generateMerchandiseCartItems(
  offer: App.MerchandiseOffer,
  variant: App.MerchandiseOfferVariant,
  options: GenerateMerchandiseCartItemsOptions = {},
): Array<App.Checkout.MerchandiseItem | App.Checkout.MerchandiseShippingItem> {
  const { quantity = 1 } = options

  /**
   * At the moment we have a 1:1 ratio of shipping item -> merchandise item being purchased
   *
   * This will (and should) change in the future to group shipping together - probably by seller
   */
  const shippingItems = fillArray(quantity, () => generateMerchandiseShippingCartItem(variant.id, variant.shippingProfileId))
  const items = fillArray(quantity, (index) => generateMerchandiseCartItem(offer, variant, { shippingId: shippingItems[index].shippingId }))

  return [...shippingItems, ...items]
}
